<template>
  <v-footer class="bg-ui-kit-bg-secondary px-0 pt-8 pt-md-6 pb-4 pb-md-8 d-flex justify-center flex-grow-0">
    <v-container class="px-4 px-md-0">
      <img
        class="mb-6"
        alt="МедТочка"
        :src="locale.logoMono"
        :width="locale.isRu ? 150 : 215"
      />
      <v-expansion-panels
        v-model="expansionPanel"
        class="d-block d-md-none"
        variant="accordion"
        elevation="0"
        multiple
        eager
      >
        <AppFooterLinksCol
          :links="LINKS.toPatient"
          expansion-panels
        >
          <template #title>Компания</template>
        </AppFooterLinksCol>
        <AppFooterLinksCol
          :links="LINKS.projects"
          expansion-panels
        >
          <template #title>Наши проекты</template>
        </AppFooterLinksCol>
        <AppFooterLinksCol
          :links="LINKS.termsOfUse"
          expansion-panels
        >
          <template #title>Условия использования</template>
        </AppFooterLinksCol>
      </v-expansion-panels>
      <v-row
        class="d-none d-md-flex px-md-0"
        justify="center"
      >
        <AppFooterLinksCol
          class="mb-4 mb-md-0"
          :links="LINKS.toPatient"
        />
        <AppFooterLinksCol
          class="app-footer__second-column mb-4 mb-md-0"
          :links="LINKS.projects"
        >
          <template #title>Наши проекты</template>
        </AppFooterLinksCol>
        <AppFooterLinksCol
          class="app-footer__third-column mb-2 mb-md-0"
          :links="LINKS.termsOfUse"
        >
          <template #title>Условия использования</template>
          <template #append>
            <v-img
              v-if="locale.isRu"
              class="mt-8"
              src="/images/software-register.png"
              width="45"
              height="54"
              alt="Единый реестр российских программ для ЭВМ"
            />
          </template>
        </AppFooterLinksCol>
      </v-row>
      <v-img
        v-if="locale.isRu"
        class="d-md-none mt-6"
        src="/images/software-register.png"
        width="45"
        height="54"
        alt="Единый реестр российских программ для ЭВМ"
      />
      <p class="mt-10 text-body-2 text-ui-kit-text-info">
        {{ locale.copyright }}
      </p>
    </v-container>
  </v-footer>
</template>

<script setup lang="ts">
import type { AppFooterLink } from '~/types/appFooterLink'

const locale = useAppLocale()

const LINKS = {
  toPatient: [
    { title: 'Компания МедРокет', href: useRuntimeConfig().public.mrUrl },
    { title: 'О МедТочке', to: withRouteParams({ name: 'country-about-the-project' }) },
    ...(locale.isRu ? [{ title: 'База знаний', href: useRuntimeConfig().public.helpUrl }] : []),
    { title: 'Контакты', to: withRouteParams({ name: 'country-contacts' }) },
  ],
  projects: [
    { title: locale.pdName, href: locale.pdUrl },
    { title: 'ПроТаблетки', href: useRuntimeConfig().public.ptUrl },
    { title: 'ПроБолезни', href: useRuntimeConfig().public.pbUrl },
    { title: 'МедЛок', href: useRuntimeConfig().public.mlUrl },
    { title: 'МедФлекс', href: locale.mfUrl },
    ...(locale.isRu ? [{ title: 'МедТочка для врача', href: locale.mtVrachUrl }] : []),
  ],
  termsOfUse: [
    { title: 'Пользовательское соглашение', to: withRouteParams({ name: 'country-terms-of-use' }) },
    { title: 'Обработка персональных данных', to: withRouteParams({ name: 'country-privacy-policy' }) },
    { title: 'Лицензионное соглашение', to: withRouteParams({ name: 'country-license-agreement' }) },
    ...(locale.isRu
      ? [
        { title: 'Публичная оферта', to: withRouteParams({ name: 'country-public-offer' }) },
        { title: 'Руководство пользователя', href: '/documents/users-guide.pdf' },
      ]
      : []),
  ],
} satisfies Record<string, AppFooterLink[]>

const expansionPanel = ref([0])
</script>

<style scoped lang="scss">
.app-footer {
  &__second-column {
    padding-left: 50px;
  }

  &__third-column {
    padding-left: 100px;
  }
}
</style>
